import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { TitleService } from '../title/title.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(
    private _navController: NavController,
    private _titleService: TitleService,
  ) {}

  routeToErrorPage(): Promise<boolean> {
    const title = this._titleService.getPageTitle();
    return this._navController.navigateForward('/app/error', {
      animated: false,
      state: { title },
    });
  }
}
